import React from 'react';
import { arrayOf, string } from 'prop-types';
import { isExternalLink } from '../../utils/url';

function CommunityResourceCard({
  Url: url,
  Heading: heading,
  Teaser: teaser,
  ResourceTypes: resourceTypes,
  Eligibility: eligibility,
  AgeGroups: ageGroups,
  Partners: partners,
  externalLinkText,
  resourceTypesLabel,
  ageGroupsLabel,
  eligibilityLabel,
  partnersLabel
}) {
  const isExternal = isExternalLink(url);
  return (
    <a
      href={url}
      className={`program-result-card hover-card community-resource-card ${
        isExternal ? 'faculty-staff-listing__external-card' : ''
      }`}
      target={isExternal ? '_blank' : null}
      rel={isExternal ? 'noopener noreferrer' : null}
    >
      {isExternal && (
        <span className="visually-hidden">{externalLinkText}</span>
      )}
      <div className="program-result-card__program-name-on-campus-wrapper">
        <h3 className="program-result-card__program-name">{heading}</h3>
      </div>
      {(resourceTypes && resourceTypes.length > 0) ||
      (ageGroups && ageGroups.length > 0) ||
      (eligibility && eligibility.length > 0) ||
      (partners && partners.length > 0) ? (
          <div className="program-result-card__description">
            <div className="program-result-card__program-degree">
              {resourceTypes && resourceTypes.length > 0 ? (
                <p>
                  <strong>{resourceTypesLabel}:</strong>{' '}
                  {resourceTypes.join(', ')}
                </p>
              ) : null}
              {ageGroups && ageGroups.length > 0 ? (
                <p>
                  <strong>{ageGroupsLabel}:</strong> {ageGroups.join(', ')}
                </p>
              ) : null}
              {eligibility && eligibility.length > 0 ? (
                <p>
                  <strong>{eligibilityLabel}:</strong> {eligibility.join(', ')}
                </p>
              ) : null}
              {partners && partners.length > 0 ? (
                <p>
                  <strong>{partnersLabel}:</strong> {partners.join(', ')}
                </p>
              ) : null}
            </div>
          </div>
        ) : null}
      <p className="program-result-card__teaser">{teaser}</p>
    </a>
  );
}

CommunityResourceCard.propTypes = {
  Url: string.isRequired,
  Heading: string.isRequired,
  Teaser: string.isRequired,
  ResourceTypes: arrayOf(string),
  Eligibility: arrayOf(string),
  AgeGroups: arrayOf(string),
  Partners: arrayOf(string),
  externalLinkText: string.isRequired,
  resourceTypesLabel: string.isRequired,
  ageGroupsLabel: string.isRequired,
  eligibilityLabel: string.isRequired,
  partnersLabel: string.isRequired
};

export default React.memo(CommunityResourceCard);
